import { motion, useMotionValue, useSpring, useTransform, useScroll } from "framer-motion";
import { useRef } from "react";

const lines = ["Digital gifts.", "Paid in crypto.", "Delivered fast."];

const HeroCard = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [14, -14]), { stiffness: 120, damping: 14 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-18, 18]), { stiffness: 120, damping: 14 });
  const move = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  return (
    <div onMouseMove={move} onMouseLeave={() => { mx.set(0); my.set(0); }} className="relative flex items-center justify-center [perspective:1000px]">
      <motion.div
        data-testid="hero-3d-card"
        style={{ rotateX: rx, rotateY: ry }}
        initial={{ opacity: 0, y: 40, rotateZ: -8 }}
        animate={{ opacity: 1, y: 0, rotateZ: -6 }}
        transition={{ duration: 1.1, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="relative aspect-[1.6] w-full max-w-[420px] overflow-hidden rounded-3xl border border-white/10 shadow-[0_40px_120px_-20px_rgba(139,92,246,0.55)] [transform-style:preserve-3d]"
      >
        <img src="/products/card50.jpg" alt="GIFTS card" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-[#0f0c20]/70 via-transparent to-white/10" />
        <div className="absolute bottom-5 left-6 right-6 flex items-end justify-between [transform:translateZ(40px)]">
          <span className="font-display text-2xl font-semibold text-white">VAULT GIFT</span>
          <span className="font-mono text-xs tracking-widest text-zinc-300">•••• 2026</span>
        </div>
      </motion.div>
    </div>
  );
};

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 120]);
  return (
    <section ref={ref} data-testid="hero-section" className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 pb-10 pt-12 md:grid-cols-[1.2fr_1fr] md:pt-20">
      <div>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className="mb-6 text-xs font-semibold uppercase tracking-[0.3em] text-violet-300">
          Keys · Subscriptions · Gift cards
        </motion.p>
        <h1 className="font-display text-4xl font-semibold leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {lines.map((l, i) => (
            <span key={l} className="block overflow-hidden pb-1">
              <motion.span
                className={`block ${i === 1 ? "text-violet-400" : ""}`}
                initial={{ y: "105%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              >
                {l}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }} className="mt-6 max-w-md text-base text-zinc-400">
          Pick a product, pay with BTC, ETH, USDT or LTC, and get your code on your order page.
        </motion.p>
      </div>
      <motion.div style={{ y }}><HeroCard /></motion.div>
    </section>
  );
};
